if (document.body.classList.contains('template-collection')) {
document.addEventListener('click', function(e) {
  const button = e.target.closest('#surveyButton');
  if (button) {
    (window.CE_API || (window.CE_API = [])).push(function() {
      CE2.showSurvey("f78fc68f-3bd4-420a-ab1e-281c31aa9277");
    });
  }
});
}